import Vue from 'vue'
import Router from 'vue-router'
import Main from 'pages/Main'
import home from 'pages/home/home'

Vue.use(Router)
const router = new Router({
  linkActiveClass: 'cur',
  routes: [{
      path: '/login',
      name: 'login',
      component: () => import('@/pages/login/index'),
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/pages/login/register'),
    },
    {
      path: '/forgetPsd',
      name: 'forgetPsd',
      component: () => import('@/pages/login/forgetPsd'),
    },
    {
      path: '/',
      //name: 'Main',
      redirect: '/home',
      component: Main,
      children: [
        {
          path: '/home',
          name: 'home',
          component: home,
          meta: {
            auth: true
          }
        },
        {
          path: '/situation',
          name: 'situation',
          component: () => import('@/pages/conditon'),
          meta: {
            auth: true
          }
        },
        {
          path: '/my',
          name: 'my',
          component: () => import('@/pages/my/index'),
        }
      ]
    },
    // 兑换
    {
      path: '/exchange',
      name: 'exchange',
      component: () => import('@/pages/exchange/index'),
    },
    {
      path: '/exchangeRecord',
      name: 'exchangeRecord',
      component: () => import('@/pages/exchange/exchangeRecord'),
    },
    {
      path: '/feed',
      name: 'feed',
      component: () => import('@/pages/feed/index'),
    },
    {
      path: '/profit',
      name: 'profit',
      component: () => import('@/pages/feed/profit'),
    },
    {
      path: '/dynamic',
      name: 'dynamic',
      component: () => import('@/pages/feed/dynamic'),
    },
    {
      path: '/feed-charge',
      name: 'feed-charge',
      component: () => import('@/pages/feed/charge'),
    },
    {
      path: '/feed-output',
      name: 'feed-output',
      component: () => import('@/pages/feed/output'),
    },
    {
      path: '/adopt-record',
      name: 'adopt-record',
      component: () => import('@/pages/adopt/index'),
    },
    {
      path: '/adopt-detail/:id',
      name: 'adopt-detail',
      component: () => import('@/pages/adopt/detail'),
    },
    {
      path: '/tranform-record',
      name: 'tranform-record',
      component: () => import('@/pages/adopt/tranform'),
    },
    {
      path: '/appointment-record',
      name: 'appointment-record',
      component: () => import('@/pages/adopt/appointment'),
    },
    {
      path: '/popularize',
      name: 'popularize',
      component: () => import('@/pages/popularize/index'),
    },
    {
      path: '/safe',
      name: 'safe',
      component: () => import('@/pages/safe/index'),
    },
    {
      path: '/lower',
      name: 'lower',
      component: () => import('@/pages/safe/lower'),
    },
    {
      path: '/high',
      name: 'high',
      component: () => import('@/pages/safe/high'),
    },
    {
      path: '/confirm',
      name: 'confirm',
      component: () => import('@/pages/safe/confirm'),
    },
    {
      path: '/setting',
      name: 'setting',
      component: () => import('@/pages/my/setting'),
    },
    {
      path: '/info',
      name: 'info',
      component: () => import('@/pages/my/info'),
    },
    
    {
      path: '/realAudio',
      name: 'realAudio',
      component: () => import('@/pages/my/realAudio'),
    },
    {
      path: '/article',
      name: 'article',
      component: () => import('@/pages/article/index'),
    },
    {
      path: '/email',
      name: 'email',
      component: () => import('@/pages/article/email'),
    },
    {
      path: '/email-detail',
      name: 'email-detail',
      component: () => import('@/pages/article/email-detail'),
    },
    {
      path: '/sending',
      name: 'sending',
      component: () => import('@/pages/article/sending'),
    },
    {
      path: '/article-detail/:id',
      name: 'article-detail',
      component: () => import('@/pages/article/detail'),
    },
    {
      path: '/receipt-manage',
      name: 'receipt-manage',
      component: () => import('@/pages/receipt-manage/index'),
    },
    {
      path: '/team',
      name: 'team',
      component: () => import('@/pages/team/index'),
    },
    {
      path: '/billMange',
      name: 'billMange',
      component: () => import('@/pages/billMange/index'),
    },
  ]
})

const whiteList = ['/register','/forgetPsd']

router.beforeEach((to, from, next) => { 
  if (to.path == '/login' ) {
    if(localStorage.getItem('userToken')){
      next('/home');
    }else{
      next();
    }
  } else {
    if(whiteList.indexOf(to.path)<0 && !localStorage.getItem('userToken')){
      next('/login');
    }
    else{
      next();
    }
  } 
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js